window.$ = require("jquery");

//https://sweetalert2.github.io/
import Swal from "sweetalert2";

//https://flatpickr.js.org/
const flatpickr = require("flatpickr");
flatpickr.default.localize(require("flatpickr/dist/l10n/az").default.az);

//https://www.dropzone.dev/
import Dropzone from "dropzone";

//https://github.com/js-cookie/js-cookie
import Cookies from "js-cookie";

//https://clipboardjs.com/
import ClipboardJS from "clipboard";

//https://datatables.net/
import DataTable from "datatables.net-bs5";
import "datatables.net-fixedcolumns-bs5";
import "datatables.net-fixedheader-bs5";
import "datatables.net-responsive-bs5";
import "datatables.net-rowreorder-bs5";
import "datatables.net-autofill-bs5";

//https://select2.org/
window.select2 = require("select2");
require("select2/dist/js/i18n/az");
$.fn.select2.defaults.set("theme", "bootstrap-5");
$.fn.select2.defaults.set("language", "az");
$.fn.select2.defaults.set("placeholder", {
  id: "",
  text: "Birini seçin",
});
$.fn.select2.defaults.set("allowClear", true);

//https://swisnl.github.io/jQuery-contextMenu
// window.contextMenu = require("jquery-contextmenu");
// require("jquery-contextmenu/dist/jquery.ui.position.min");

require("./vendor/jquery.plugin");
window.countdown = require("./vendor/jquery.countdown");

let tableColumns = [];
let tableColumnsJson = $("#tableColumns");
if (tableColumnsJson.length > 0) {
  tableColumns = Object.keys(JSON.parse(tableColumnsJson.text())).map((key) => {
    return { data: key };
  });
}

$.extend(true, $.fn.dataTable.defaults, {
  columns: tableColumns,
  dom:
    "<'mt-3 mb-4'" +
    "<'row g-0'<'col-sm-6 d-flex align-items-center mb-2 mb-sm-0'li><'col-sm-6 d-flex justify-content-start justify-content-sm-end'p>>" +
    "tr" +
    "<'row g-0'<'col-sm-6 d-flex align-items-center mb-2 mb-sm-0'li><'col-sm-6 d-flex justify-content-start justify-content-sm-end'p>>>",
  deferRender: true,
  processing: true,
  retrieve: true,
  autoWidth: false,
  serverSide: true,
  pagingType: "numbers",
  language: {
    lengthMenu: "_MENU_",
    emptyTable: "Məlumat tapılmadı",
    info: "_TOTAL_ | _START_ - _END_",
    infoFiltered: "",
    infoEmpty: "Axtarış nəticəsi: 0",
  },
  ajax: {
    type: "POST",
    data: function (d) {
      d.csrfmiddlewaretoken = document.querySelector(
        "input[name=csrfmiddlewaretoken]",
      ).value;
    },
  },
  lengthMenu: [
    [10, 25, 50, 100, 250],
    [10, 25, 50, 100, 250],
  ],
  pageLength: 25,
  searching: false,
  info: true,
  responsive: true,
  ordering: false,
  rowCallback: function (nRow, aData) {
    if ($(this).find("th[data-column=actions]").length > 0) {
      const rowActions = `<div class="btn-group" role="group">
      <button type="button" class="rowActionMenuBtn btn btn-sm btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        Əməliyyat
      </button>
      <ul class="rowActionMenu dropdown-menu rounded-1 shadow">
        <div class="d-flex justify-content-center align-items-center p-2">
          <div class="spinner-border text-secondary" role="status" style="border-width: 1px"></div>
        </div>
      </ul>
    </div>`;
      $(nRow).find("td:last-of-type").append(rowActions);
    }
    if ("id" in aData) {
      $(nRow).attr("id", aData["id"]);
    }
    if ("table_row_class" in aData) {
      $(nRow).addClass(aData["table_row_class"]);
    }
  },
});

export { Dropzone, Cookies, DataTable, Swal, ClipboardJS };
